(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-slideshow')) {
    customElements.define('hero-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.hero-slideshow__slide'));
        this.current = 0;
        this.delay = Math.max(3, Number(this.dataset.interval) || 5) * 1000;
        if (this.slides.length < 2) return;
        this.slides.forEach((slide, index) => {
          const video = slide.querySelector('video');
          if (!video) return;
          if (index === 0) video.play().catch(() => {});
          else video.pause();
        });
        this.start();
        this.addEventListener('mouseenter', this.pause);
        this.addEventListener('mouseleave', this.start);
        this.addEventListener('focusin', this.pause);
        this.addEventListener('focusout', this.start);
      }

      disconnectedCallback() {
        this.stop();
      }

      start = () => {
        this.stop();
        this.timer = window.setInterval(() => this.show((this.current + 1) % this.slides.length), this.delay);
      };

      stop = () => window.clearInterval(this.timer);
      pause = () => this.stop();

      show(index) {
        if (!this.slides[index]) return;
        this.slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          const video = slide.querySelector('video');
          if (video) {
            if (active) video.play().catch(() => {});
            else video.pause();
          }
        });
        this.current = index;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nika-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initShowcase(root) {
      if (!root || root.dataset.nikaReady === 'true') return;
      root.dataset.nikaReady = 'true';
      const cards = Array.from(root.querySelectorAll('.nika-showcase__card'));
      const filters = Array.from(root.querySelectorAll('[data-filter]'));
      const filterWrap = root.querySelector('.nika-showcase__filters');
      const countLabel = root.querySelector('[data-count-label]');
      const more = root.querySelector('[data-show-more]');
      const menu = root.querySelector('.nika-showcase__menu');
      let activeFilter = 'all';
      const initialCount = Number(root.dataset.initialCount || 8);
      const labels = { all: root.dataset.allLabel || 'All' };

      if (filterWrap) {
        const seen = new Set(['all']);
        filters.forEach(function (button) {
          const value = button.dataset.filter;
          if (seen.has(value)) button.remove();
          else seen.add(value);
        });
      }

      function update() {
        let shown = 0;
        let matches = 0;
        cards.forEach(function (card) {
          const matchesFilter = activeFilter === 'all' || card.dataset.category === activeFilter;
          if (matchesFilter) {
            matches += 1;
            card.hidden = shown >= initialCount;
            if (!card.hidden) shown += 1;
          } else {
            card.hidden = true;
          }
        });
        if (countLabel) countLabel.textContent = matches + ' ' + (matches === 1 ? (root.dataset.projectSingular || 'piece') : (root.dataset.projectPlural || 'pieces'));
        if (more) more.hidden = matches <= initialCount;
      }

      filters.forEach(function (button) {
        button.addEventListener('click', function () {
          activeFilter = button.dataset.filter;
          filters.forEach(function (item) {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          update();
        });
        button.setAttribute('aria-pressed', button.dataset.filter === 'all' ? 'true' : 'false');
      });
      if (more) {
        more.addEventListener('click', function () {
          cards.forEach(function (card) {
            if (activeFilter === 'all' || card.dataset.category === activeFilter) card.hidden = false;
          });
          more.hidden = true;
        });
      }
      if (menu) {
        root.addEventListener('click', function (event) {
          if (!menu.contains(event.target)) menu.open = false;
        });
      }
      if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.08 });
        cards.forEach(function (card) { observer.observe(card); });
      } else {
        cards.forEach(function (card) { card.classList.add('is-visible'); });
      }
      update();
    }
    function initAll(scope) {
      (scope || document).querySelectorAll('.nika-showcase').forEach(initShowcase);
    }
    initAll(document);
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      const root = event.target.querySelector('.nika-showcase');
      if (root) delete root.dataset.nikaReady;
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
